/**
 *	Application State Management
 *	Singleton to store global values / state we may need to react to.
 */

let instance = null;

class State {

	constructor() {

		if ( !instance ) instance = this;

		/* Initial data */
		this._category = ''
		this._product = ''
		//this._productimage = ''
		this._availableservice = ''
		this._ispmnotavailable = ''
		this._selectedservice = ''
		this._selectedisrservice = ''
		this._selectedStoreAndSlot = ''
		this._islockersavailable = ''
		this._isdpdSlotsavailable = ''
		this._tsoutcome = ''
/*		this._lucidref = ''
		this._symptomcode1 = ''
		this._symptomcode2 = ''
		this._symptomcode3 = ''
		this._warrantyexception = ''*/
		this._selectedFlipColour = ''
		this._debug = false
		this._name = 'support-repair'
		this._QSIRepairBookingFlag = '';
		this._isUBPrice=false;
		this._isRedirectedToSALogin = false;
		this._isUserLoggedIn = false;
		this._howDoIFindFaqHash = '';
		this._userInfo = {};
		this.userInfo.firstName = '';
		this.userInfo.lastName = '';
		this.userInfo.email = '';
		this.userInfo.guid = '';
		this.productImage = '';
		this._saProductDetail = [];
		this._popJourney = []

		switch ( window.location.host.replace('.samsung.com','') ) {
			case 'www':
				this._env = 'production'
				break;
			case 'qaweb':
				this._env = 'staging'
				break;
			default:
				this._env = 'development'
		}

		return instance;

	}

	initState(obj) {

		this._apihost = obj._apihost;
		$.publish('app:apihost', obj._apihost);
		this._category = obj._category;
		$.publish('app:category', obj._category);
		this._product = obj._product;
		$.publish('app:product', obj._product);
		this._productimage = obj._productImage;
		$.publish('app:productimage', obj._productImage);
		this._availableservice = obj._availableservice;
		$.publish('app:availableservice', obj._availableservice);
		this._ispmnotavailable = obj._ispmnotavailable;
		$.publish('app:availableservice', obj._ispmnotavailable);
		this._ismaintenanceflagon = obj._ismaintenanceflagon;
		$.publish('app:ismaintenanceflagon', obj._ismaintenanceflagon);
		this._islockersflagon = obj._islockersflagon;
		$.publish('app:islockersflagon', obj._islockersflagon);
		this._selectedservice = obj._selectedservice;
		$.publish('app:selectedservice', obj._selectedservice);
		this._selectedisrservice = obj._selectedisrservice;
		$.publish('app:selectedisrservice', obj._selectedisrservice);
		this._howDoIFindFaqHash = obj._howDoIFindFaqHash;
		$.publish('app:selectedisrservice', obj._howDoIFindFaqHash);
		this._selectedstoreid = obj._selectedstoreid;
		$.publish('app:selectedstoreid', obj._selectedstoreid);
		this._islockersavailable = obj._islockersavailable;
		$.publish('app:islockersavailable', obj._islockersavailable);
		this._isdpdSlotsavailable = obj._isdpdSlotsavailable;
		$.publish('app:isdpdSlotsavailable', obj._isdpdSlotsavailable);
		this._selectedFlipColour = obj._selectedFlipColour;
		$.publish('app:selectedFlipColour', obj._selectedFlipColour);
		this._isRedirectedToSALogin = obj._isRedirectedToSALogin;
		$.publish('app:isRedirectedToSALogin', obj._isRedirectedToSALogin);
		this._isUBPrice = obj._isUBPrice;
		$.publish('app:isUBPrice', obj._isUBPrice);
		this._tsoutcome = obj._tsoutcome;
		$.publish('app:tsoutcome', obj._tsoutcome);

		this._selectedStoreAndSlot = obj._selectedStoreAndSlot;
		$.publish('app:selectedStoreAndSlot', obj._selectedStoreAndSlot);


		this._QSIRepairBookingFlag = obj._QSIRepairBookingFlag;
		$.publish('app:QSIRepairBookingFlag', obj._QSIRepairBookingFlag);
		this._userInfo = obj._userInfo;
		$.publish('app:userInfo', obj._userInfo);

		this._saProductDetail = obj._saProductDetail;
		$.publish('app:saProductDetail', obj._saProductDetail);

		this._popJourney = obj._popJourney
		$.publish('app:popJourney', obj._popJourney);
		

		window.state.productImage =  obj.productImage;




	}

	/**
	 * 	Getters & Setters for Applciation State
	 * 	Publishes pub/sub event
	 */

	/* Set the api host to be used */
	get apihost() {
		return this._apihost
	}
	set apihost( value ) {
		this._apihost = value
		$.publish('app:apihost', value)
	}

	/* Selected category */
	get category() {
		return this._category
	}
	set category( value ) {
		this._category = value
		$.publish('app:category', value)
	}

	/* Selected product */
	get product() {
		return this._product
	}
	set product( value ) {
		this._product = value
		$.publish('app:product', value)
	}

	get productimage() {
		return this.productimage
	}
	set productimage( value ) {
		this.productimage = value
		$.publish('app:productimage', value)
	}


	

	/* Maintenance message */
	get availableservice() {
		return this._availableservice
	}
	set availableservice( value ) {
		this._availableservice = value
		$.publish('app:availableservice', value)
	}

	get ispmnotavailable() {
		return this._ispmnotavailable
	}
	set ispmnotavailable( value ) {
		this._ispmnotavailable = value
		$.publish('app:ispmnotavailable', value)
	}

	/* Maintenance Message */
	get ismaintenanceflagon() {
		return this._ismaintenanceflagon
	}
	set ismaintenanceflagon( value ) {
		this._ismaintenanceflagon = value
		$.publish('app:ismaintenanceflagon', value)
	}

	/* Maintenance Message */
	get islockersflagon() {
		return this._islockersflagon
	}
	set islockersflagon( value ) {
		this._islockersflagon = value
		$.publish('app:islockersflagon', value)
	}

	/* Selected Service */
	get selectedservice() {
		return this._selectedservice
	}
	set selectedservice( value ) {
		this._selectedservice = value
		$.publish('app:selectedservice', value)
	}

	get howDoIFindFaqHash() {
		return this._howDoIFindFaqHash
	}
	set howDoIFindFaqHash( value ) {
		this._howDoIFindFaqHash = value
		$.publish('app:howDoIFindFaqHash', value)
	}



	/* Selected Service */
	get selectedisrservice() {
		return this._selectedisrservice
	}
	set selectedisrservice( value ) {
		this._selectedisrservice = value
		$.publish('app:selectedisrservice', value)
	}

	/* Selected Store ID */
	get selectedstoreid() {
		return this._selectedstoreid
	}
	set selectedstoreid( value ) {
		this._selectedstoreid = value
		$.publish('app:selectedstoreid', value)
	}

	/* islockers available on the store */
	get islockersavailable() {
		return this._islockersavailable
	}
	set islockersavailable( value ) {
		this._islockersavailable = value
		$.publish('app:islockersavailable', value)
	}

	/* is Dpd slots selection available for the selected service */
	get isdpdSlotsavailable() {
		return this._isdpdSlotsavailable
	}
	set isdpdSlotsavailable( value ) {
		this._isdpdSlotsavailable = value
		$.publish('app:isdpdSlotsavailable', value)
	}

	/** Bespoke Flip 3 colour change **/
	get selectedFlipColour() {
		return this._selectedFlipColour
	}
	
	set selectedFlipColour( value ) {
		this._selectedFlipColour = value
		$.publish('app:selectedFlipColour', value)
	}

	get isUBPrice() {
		return this._isUBPrice
	}
	
	set isUBPrice( value ) {
		this._isUBPrice = value
		$.publish('app:isUBPrice', value)
	}

	/** User sent to SA Login page Flag **/
	get isRedirectedToSALogin() {
		return this._isRedirectedToSALogin
	}
	
	set isRedirectedToSALogin( value ) {
		this._isRedirectedToSALogin = value
		$.publish('app:isRedirectedToSALogin', value)
	}


	get isUserLoggedIn() {
		return this._isUserLoggedIn
	}
	
	set isUserLoggedIn( value ) {
		this._isUserLoggedIn = value
		$.publish('app:isUserLoggedIn', value)
	}


	

	/* Lucid Ref */
	get tsoutcome() {
		return this._tsoutcome
	}
	set tsoutcome( value ) {
		this._tsoutcome = value
		$.publish('app:tsoutcome', value)
	}

	get selectedStoreAndSlot() {
		return this._selectedStoreAndSlot
	}
	set selectedStoreAndSlot( value ) {
		this._selectedStoreAndSlot = value
		$.publish('app:selectedStoreAndSlot', value)
	}

	

	get userInfo() {
		return this._userInfo
	}
	set userInfo( value ) {
		this._userInfo = value
		$.publish('app:userInfo', value)
	} 

	get saProductDetail() {
		return this._saProductDetail
	}
	set saProductDetail( value ) {
		this._saProductDetail = value
		$.publish('app:saProductDetail', value)
	}

		

	/* Lucid Ref */
/*	get lucidref() {
		return this._lucidref
	}
	set lucidref( value ) {
		this._lucidref = value
		$.publish('app:lucidref', value)
	}
*/
	/* Quiltrics variable to set booking success */
	get QSIRepairBookingFlag() {
		return this._QSIRepairBookingFlag
	}
	set QSIRepairBookingFlag( value ) {
		this._QSIRepairBookingFlag = value
		$.publish('app:QSIRepairBookingFlag', value)
	}



/*	get symptomcode1() {
		return this._symptomcode1
	}
	set symptomcode1( value ) {
		this._symptomcode1 = value
		$.publish('app:symptomcode1', value)
	}


	get symptomcode2() {
		return this._symptomcode2
	}
	set symptomcode2( value ) {
		this._symptomcode2 = value
		$.publish('app:symptomcode2', value)
	}


	get symptomcode3() {
		return this._symptomcode3
	}
	set symptomcode3( value ) {
		this._symptomcode3 = value
		$.publish('app:symptomcode3', value)
	}


	get warrantyexception() {
		return this._warrantyexception
	}
	set warrantyexception( value ) {
		this._warrantyexception = value
		$.publish('app:warrantyexception', value)
	}*/

	/* POP Journey */

	get POPJourney() {
		return this._popJourney
	}

	set POPJourney( value ) {
		this._popJourney = value
		$.publish('app:popJourney', value)
	}

	/* Debug mode */
	get debug() {
		return this._debug
	}
	set debug( value ) {
		this._debug = value
		$.publish('app:debug', value)
	}

	/* Project Name */
	get name() {
		return this._name
	}
	set name( value ) {
		this._name = value
		$.publish('app:name', value)
	}

	/* Environment */
	get env() {
		return this._env
	}
	set env( value ) {
		this._env = value
		$.publish('app:env', value)
	}

};

export default State
